import React, { useState } from 'react'
import ReactInterval from 'react-interval'
import './styles.scss'

export const Counter = () => {
  const [value, setValue] = useState(0)

  // Births 2020: 139980000 -> https://ourworldindata.org/grapher/births-and-deaths-projected-to-2100
  // Seconds per year: 31556952
  // Births per Second: 4.435789616183464

  const birthsperyear = 139980000 // 2020 https://ourworldindata.org/grapher/births-and-deaths-projected-to-2100
  const secondsperyear = 366 * 24 * 60 * 60 // 2020 https://www.convertunits.com/dates/from/Jan+1,+2020/to/Jan+1,+2021
  return (
    <div className='Counter'>
      <div className='info'>Geborene Kinder seit Sie diesen Artikel lesen:</div>
      <ReactInterval
        timeout={1000}
        enabled={true}
        callback={() => setValue(value + birthsperyear / secondsperyear)}
      />
      <b>{Math.round(value)}</b>
      <div className='mapkey'>
        <div className='swatch' />
        ein Baby wurde geboren
      </div>
      <div className='src'>
        Quelle:{' '}
        <a
          href='https://ourworldindata.org/grapher/births-and-deaths-projected-to-2100'
          target='_blank'
        >
          OurWorldInData
        </a>
        ,{' '}
        <a
          href='https://worldpopulationreview.com/country-rankings/birth-rate-by-country'
          target='_blank'
        >
          World Population Review
        </a>
      </div>
    </div>
  )
}
